export function getResearchersPage(state: any) {
    return state.researcher.list;
}

export function getResearchersTabs(state: any) {
    return state.researcher.tabs;
}

export function hasMoreResearchers(state: any) {
    const { rows, meta } = getResearchersPage(state);

    return meta.totalSize > rows.length;
}

export function isLoading(state: any) {
    return state.researcher.isLoading;
}

export function getResearcher(state: any) {
    return state.researcher.one;
}

export function getSelectedThemeSlug(state: any) {
    return state.researcher.selectedThemeSlug;
}

export function getSelectedTabIndex(state: any) {
    return state.researcher.selectedTabIndex;
}

export function getStatusBySelectedTab(state: any) {
    const tabIndex = getSelectedTabIndex(state);

    return state.researcher.tabs[tabIndex].status;
}
